// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_b3-4";
export var collapsed = "_b3-1";
export var headerBar = "_b3-0";
export var leftHeaderContent = "_b3-3";
export var subjectContainer = "_b3-2";